// extracted by mini-css-extract-plugin
export default {"centerUnderline":"PersonList__centerUnderline___ZTgnO"};